import { render, staticRenderFns } from "./Kostenmanagement.vue?vue&type=template&id=c3420704&"
import script from "./Kostenmanagement.vue?vue&type=script&lang=js&"
export * from "./Kostenmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports